import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';

import getEnvConfig from '../../../../../utils/config/env';
import { PersonalBroadcastProps } from './personal-broadcast.interface';

export const personalBroadcastsApi = createApi({
    reducerPath: 'exports',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL,
        prepareHeaders: headers => {
            const token = localStorage.getItem('accessToken');
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['Broadcasts'],

    endpoints: builder => ({
        createPersonaBroadcast: builder.mutation<
            PersonalBroadcastProps[],
            { id: number; body: FormData }
        >({
            query: ({ id, body }) => ({
                url: `/shops/${id}/personal-message/send`,
                method: 'POST',
                body: body,
            }),
            transformResponse: (response: {
                data: PersonalBroadcastProps[];
            }) => {
                return response.data;
            },
            invalidatesTags: ['Broadcasts'],
        }),
    }),
});

export const { useCreatePersonaBroadcastMutation } = personalBroadcastsApi;
